// IMPORTANT: Import API config first to set up axios interceptors before any other imports
import './services/api';

// IMPORTANT: Import Ant Design React 19 compatibility patch for static notifications
import '@ant-design/v5-patch-for-react-19';

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./pages/index.css";
import App from "./App";
import store from "./store";
import { AuthProvider } from "./contexts/auth/AuthProvider";
// PermissionsProvider removed - permissions now handled via utils/permissions.js
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </Provider>
  </React.StrictMode>
);
reportWebVitals();
